import { GET_MEMBER_REPORT_RANGE } from './constants';

export default {
  [GET_MEMBER_REPORT_RANGE](state) {
    return {
      start: state.memberReportRange?.[0] || null,
      end: state.memberReportRange?.[1] || null,
    };
  },
  dateTypeWithRange(state) {
    return {
      dates: state.memberReportRange,
      type: state.searchDateType,
    };
  },
};
